import React,{useEffect} from 'react';
import {btnSetColor_CBack,TableDatePicker} from '../../function_lib/common_lib';
import {Custom_Alert,Alert_Content} from '../../components/custom_alert';
export function Comp_Add_Port_Watched_Records(props){
    const savePortWatchesRec=()=>{
        btnSetColor_CBack(this,"frmAddPortWatchesRecords","addPortWatchesRecord",function(data,msg){
            Custom_Alert("View",msg,false);
        })
      }

  //alert(JSON.stringify(props.editUser));
   useEffect(()=>{

   },[props.editUser]);
  
    return(<div className="modal fade bd-example-modal-xl"  id="divAddPortWatchesRec" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xl" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Port Watches Record </h5>
          <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        <form id="frmAddPortWatchesRecords" name="frmAddPortWatchesRecords">
        <input type="hidden" id="m_type" name="m_type" value={"addPortWatchesRecord"}/>
            <input type="hidden" id="res_func" name="res_func" value={"useit"}/>
            <input type="hidden" id="global_token" name="global_token" value={props.logUser[0]["app_user_id"]}/>
            <input type="hidden" id="local_token" name="local_token" value={props.logUser[0]["id"]}/>
            
        <div className="modal-body">
             {/* form content  */}
             <div class="container port_watches_formm text-start">
    <h2 class="text-center mb-4">Record of port watches Form</h2>
    
        <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Ship Name:</strong></label>
                <input name="ship_name" id="ship_name" type="text" class="form-control" placeholder="Enter ship name" required/>
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Ship Type:</strong></label>
                <input name="ship_type" id="ship_type" type="text" class="form-control" placeholder="Enter ship type" required/>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Capacity:</strong></label>
                <input name="capacity" id="capacity" type="text" class="form-control" placeholder="Enter capacity" required/>
            </div>
            <div class="col-md-6 form-group">
                <label><strong>IMO Number:</strong></label>
                <input name="imo_no" id="imo_no"  type="text" class="form-control" placeholder="Enter imo number" required/>
            </div>
        </div>

         <div class="row">
         <div class="col-md-6 form-group">
                <label><strong>Name of Port:</strong></label>
                <input name="name_port_terminal" id="name_port_terminal" type="text" class="form-control" required/>
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Date:</strong></label>
                <div className="input-group input-group-sm">
                <TableDatePicker refName="port_watch_date" />
                </div>
                {/* <input name="port_watch_date" id="port_watch_date" type="text" class="form-control" required/> */}
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Time From:</strong></label>
                <input name="time_from" id="time_from" type="time" class="form-control" required/>
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Time To:</strong></label>
                <input name="time_to" id="time_to" type="time" class="form-control" required/>
            </div>
        </div>

        <div class="row">
           
            <div class="col-md-6 form-group">
                <label><strong>Voyage Number:</strong></label>
                <input name="voyage_number" id="voyage_number" type="text" class="form-control" placeholder="Enter voyage number" required/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Description of cargo operation:<br/> (loading/discharging/others)</strong></label>
                <textarea class="form-control" id="cargo_operation" name="cargo_operation">

                </textarea>
                {/* <input name="description_of_cargo_operation" type="text" class="form-control" placeholder="Enter Description of cargo operation" required/> */}
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Remarks <br/> (describe activities carried out during watch):</strong></label>
                <textarea class="form-control" id="remarks" name="remarks">

                </textarea>
                {/* <input name="remarks" type="number" class="form-control" placeholder="Enter remarks" required/> */}
            </div>
        </div>

       {/* <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>OOW Signature </strong></label>
                <input name="ow_signature" type="text" class="form-control"/>
            </div>
       </div> */}

     
</div>
             {/* end of form contacnt */}
        </div>
        <div className="modal-footer">
        <div id="getReponse" style={{color:"red"}}></div>
          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" data-dismiss="modal">Close</button>
          <button type="button" onClick={()=>savePortWatchesRec()} className="btn btn-primary">Save</button>
        </div>
        </form>
      </div>
      </div>
      </div>)
}

export default Comp_Add_Port_Watched_Records;